import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";

import { environment } from "src/environments/environment";

// import * as moment from 'moment';
import { AutorizationResource } from "../../../domain/models/autorization/autorization-resource.model";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/x-www-form-urlencoded",
  }),
};

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient) {}

  autorization(): Observable<AutorizationResource> {
    const client_id = environment.client_id;
    const client_secret = environment.client_secret;
    const grant_type = environment.grant_type;

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append("client_id", client_id);
    urlSearchParams.append("client_secret", client_secret);
    urlSearchParams.append("grant_type", grant_type);
    let body = urlSearchParams.toString();

    const url = `${environment.baseURLRealMS}`;
    return this.http
      .post<AutorizationResource>(`${url}`, body, httpOptions)
      .pipe(tap(this.setSession));
  }

  public isSessionActive() {
    const expiresAt = this.getExpirationSession();
    const isLoggedIn = expiresAt
      ? new Date().getTime() < expiresAt.getTime()
      : false;

    return isLoggedIn;
  }

  getAccessToken(): string {
    const accessToken = localStorage.getItem("access_token");
    return accessToken || "";
  }

  private setSession(authResult: AutorizationResource) {
    const expiresIn = authResult.expires_in;
    const expiresAt = new Date();
    expiresAt.setSeconds(expiresAt.getSeconds() + expiresIn);

    localStorage.setItem("access_token", authResult.access_token);
    localStorage.setItem("expires_at", JSON.stringify(expiresAt.getTime()));
  }

  getExpirationSession() {
    const expiration = localStorage.getItem("expires_at");
    const expiresAt = expiration ? new Date(JSON.parse(expiration)) : null;
    return expiresAt;
  }

  checkValidSession(): boolean {
    return Boolean(this.getAccessToken() && this.isSessionActive());
  }
}
